<template>
  <div class="containter grid m-5">
    <card  class=" col-12 md:col-10  surface-50">
    <template #title>
        <span class="text-700">Búsqueda de expediente catastral</span>        
    </template>
    <template #content>
        <div class="grid   ">
          <div class="col-12 md:col-4 ">
            <span id="expediente">Expediente</span>
            <InputMask aria-labelledby="expediente"  v-model="expediente"  mask="99-999-999" required="true" />
          </div>
          <div class="col-12 md:col-4 ">
            <div class="mt-3"> 
              EJEMPLO: 01-001-001
            </div>
            <div class=" "> 
              (Región-Manzana-Lote)
            </div>
          </div>
          <div class="col-12 md:col-4  mt-3">
            <Button icon="pi pi-search"  label="Busca expediente" class="p-button-info" @click="buscaExpediente" />
          </div>
          <div class="mx-auto mt-6">* Puedes obtener el número de expediente revisando en un recibo de pago anterior</div>
        </div>

    </template>
    <template #footer>
     
    </template>
  </card>
  </div>
  
    
</template>
  
<script>
  import { ref } from '@vue/reactivity';
  import { useRouter } from 'vue-router'
  import { useToast } from "primevue/usetoast";
  import predialAPI from "@/composables/PredialAPI";
  import edoCuentaStore from "@/composables/edoCuentaStore";

export default {
  setup(props,{ emit }) {
    const toast = useToast();
    const { getExpediente } = predialAPI();
    const { clearEdoCuenta} = edoCuentaStore();
    const router = useRouter();
    var expediente="";
    return {
      router,emit,expediente,getExpediente,clearEdoCuenta
    }
  },
  methods: {
    buscaExpediente() {
       
        this.emit("currentStep",2,this.expediente)
    }
  },
  activated() {
    this.clearEdoCuenta()
  },
  mounted() {
    this.clearEdoCuenta()
  }
}
</script>   
<style lang="scss">
  .theCard {
    width: 40vw;
  }
</style>